// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__Kk-vk","label":"Section_label__4ABfS","contentWrap":"Section_contentWrap__34fSj","footer":"Section_footer__33WlE","footerInner":"Section_footerInner__20dEm"};